/**
 * Lenis smooth scroll temporarily disabled — see git history
 * (akr-scroll-smooth.js) for the previous Lenis-backed implementation.
 *
 * @param {string | HTMLElement} target
 */
export function scrollTo(target) {
  const element = typeof target === 'string' ? document.querySelector(target) : target;
  element?.scrollIntoView({ behavior: 'smooth' });
}
